import { GeometryBase, Line } from "tnbase";
import { Storey } from "@/declare/interface/project/storey";
import { EventHandlerBase, Primitive, RenderItemType } from "pytha2";
import { AxisNetPrimitive } from "../primitive/AxisNetPrimitive";

/**
 * 生成竖向轴线
 */
export class EventHandlerGenVerticalAxisLine extends EventHandlerBase {
    /**
     * 判断点相同的精度
     */
    private tolerance = 1;

    /**
     * 处理器默认运行入口
     * @param data 
     * @returns 
     */
    run(data = {}) {

        const param = this.node.graph.cache.inputObject['PARAMS'];
        const storeys = param?.storeys || [];

        const groupedStoreys = storeys?.reduce((acc, storey) => {
            const regionUuid = storey?.regionUuid; // 获取 regionUuid
            // 如果 regionUuid 不在结果对象中，则初始化一个空数组
            if (!acc[regionUuid]) {
                acc[regionUuid] = [];
            }
            // 将当前楼层添加到相应的 regionUuid 组中
            acc[regionUuid].push(storey);
            return acc;
        }, {});
        const groupedStoreysArray: Storey[][] = Object.values(groupedStoreys);

        let vLinePrimitives = [];
        let layerUuid = '';

        for (let storeyList of groupedStoreysArray) {
            for (let i = 0; i < storeyList?.length - 1; i++) {
                const currentStorey = storeyList[i];
                const nextStorey = storeyList[i + 1];

                let primitiveDict = this.getPythaStorage().primitiveStore.primitiveDict;

                if (currentStorey?.axisNetUuid && nextStorey?.axisNetUuid) {
                    // 获取两组点集合
                    let { currentPoints, nextPoints } = Object.keys(primitiveDict || {}).reduce((acc, key) => {
                        let pri = primitiveDict[key];
                        if (!!pri && pri.type === "Point" && (pri as AxisNetPrimitive)?.axisNetUuid === currentStorey?.axisNetUuid) {
                            acc.currentPoints.push(pri);
                        } else if (!!pri && pri.type === "Point" && (pri as AxisNetPrimitive)?.axisNetUuid === nextStorey?.axisNetUuid) {
                            acc.nextPoints.push(pri);
                        }
                        return acc;
                    }, { currentPoints: [], nextPoints: [] });

                    // let currentAxisNet = this.getPythaStorage().primitiveStore.primitiveDict[currentStorey?.axisNetUuid];
                    // let nextAxisNet = this.getPythaStorage().primitiveStore.primitiveDict[nextStorey?.axisNetUuid];

                    // let currentPoints = Object.keys(currentAxisNet?.children)?.map(key => {
                    //     let pri = currentAxisNet?.children[key];
                    //     if (!!pri && pri.type == "Point") {
                    //         return pri;
                    //     }
                    //     return null;
                    // })?.filter(item => !!item) || [];
                    // let nextPoints = Object.keys(nextAxisNet?.children)?.map(key => {
                    //     let pri = nextAxisNet?.children[key];
                    //     if (!!pri && pri.type == "Point") {
                    //         return pri;
                    //     }
                    //     return null;
                    // })?.filter(item => !!item) || [];

                    // 判断xy相同，绘制竖向轴线
                    for (let cp of currentPoints) {
                        for (let np of nextPoints) {
                            // 判断两个点的XY值equals即可
                            if ((Math.abs(cp.getP().x - np.getP().x) < this.tolerance && Math.abs(cp.getP().y - np.getP().y) < this.tolerance)) {
                                let linePri = new AxisNetPrimitive("VerticalAxisLine");
                                let line = new Line(cp.getP(), np.getP());
                                this.addPrimitive(linePri, [line], cp.layerUuid);

                                let axisNetUuids = [currentStorey.uuid, nextStorey.uuid];
                                linePri.axisNetUuids = axisNetUuids;

                                vLinePrimitives.push(linePri);
                            }
                        }
                    }
                }
            }
        }

        return true;
    }


    /**
     * 添加一个图元
     * @param primitive 
     * @param geos  
     */
    addPrimitive(primitive: Primitive, geos: GeometryBase[], layerUuid: string) {
        const storage = this.getPythaStorage();
        primitive.geos.push(...geos);
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.geoElements = [];
            let layer = storage?.layerStore?.layers?.find(item => item.uuid === layerUuid);
            renderItem.mat?.color.set(layer.color || '#E54242');
            geos.forEach(geo => {
                let geoElementsLength = renderItem.geoElements.length;
                geo.getGeoElementsIdxList().forEach(idx => {
                    renderItem.geoElements.push(idx + geoElementsLength);
                })
            });
            renderItem.renderType = RenderItemType.LINE;
        }
        primitive.lock = true;
        primitive.layerUuid = layerUuid || null;
        primitive.colorByLayer = true;
        primitive.temporary = false;
        storage.primitiveStore.primitiveDict[primitive.uuid] = primitive;
        primitive.needRedraw = true;
    }
}